import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { paths } from '@AppRoutes/constants';
import { Modal } from '@els/els-react--modal';
import { Checkbox } from '@els/els-react--checkbox';
import { Button } from '@els/els-react--button';
import { closeDialog } from '@Containers/Dialogs/DialogsActions';
import { SessionExpiredMessage } from '@Constants/User';
import Login from '@Services/Login';
import NewRelicService from '@Services/NewRelicService';
import WindowProxy from '@Services/WindowProxy';
import { typeOfLogoutConfirmModal } from './LogoutConfirmModalConstants';

import './LogoutConfirmModal.custom.scss';

function LogoutConfirmModal(props) {
  const { content, onConfirm } = props;
  const [remember, setRemember] = useState(false);
  let unsubLocationChangeSuccess;
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    setRemember(content.remember);
    return () => {
      if (unsubLocationChangeSuccess) {
        unsubLocationChangeSuccess();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content.remember]);

  const closeWindow = () => {
    dispatch(
      closeDialog({
        id: typeOfLogoutConfirmModal,
      })
    );
  };
  const confirm = () => {
    onConfirm()
      .then(() => {
        Login.afterLogout(!remember);
        closeWindow();

        if (history) {
          unsubLocationChangeSuccess = history.listen(() => {
            WindowProxy.location.reload();
            unsubLocationChangeSuccess();
          });
        }

        NewRelicService.trackRouteChanges('/logout');
        history.push({
          pathname: paths.LOGOUT,
        });
      })
      .catch(Logger.error);
  };
  return (
    <Modal onClose={closeWindow} className="logout-confirm-modal" id="logout-confirm" shouldPreventClickOverlayToClose>
      <div>
        <h4>{content.message}</h4>
        {content.text && (
          <div className="u-els-margin-top u-els-padding-top-1o4">
            <span>{content.text}</span>
          </div>
        )}
        {content.hasRemember && (
          <div className="u-els-margin-top-2x">
            <Checkbox
              checked={remember}
              onChange={() => {
                setRemember(!remember);
              }}
              label="Remember me on this computer"
            />
          </div>
        )}
        {content.message === SessionExpiredMessage ? (
          <div className="u-els-margin-top-2x">
            <Button onClick={() => (content.forced ? closeWindow() : confirm())}>Okay</Button>
          </div>
        ) : (
          <div className="u-els-margin-top-2x">
            <Button type="secondary" onClick={() => confirm()} className="e2e-logout-confirm">
              Sign Out
            </Button>
            <Button onClick={() => closeWindow()} className="u-els-margin-left e2e-logout-continue-working">
              Continue Working
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
}

LogoutConfirmModal.defaultProps = {
  content: {},
  onConfirm: () => {},
};
LogoutConfirmModal.propTypes = {
  content: PropTypes.object,
  onConfirm: PropTypes.func,
};

export default LogoutConfirmModal;
